import axios, { AxiosError } from 'axios'
import Cookies from 'js-cookie'
import { API_KEY_LINX } from 'src/util/config'
import { SearchProductsResponse } from './dtos/search-products-response'
import { ProductsSortingKey } from 'src/util/enums/products-sorting-key'

type ProductSearchQuery = {
  search: string
  filter: string | string[]
  order: string | null
  page: number
  resultsPerPage?: string
}

type QueryParams = {
  terms: string
  page: string
  resultsPerPage: string
  sortBy: string
  productFormat: string
  showOnlyAvailable: string
  deviceId?: string
}

export const searchProductsLinx = async ({
  search,
  filter,
  order,
  page,
}: ProductSearchQuery) => {
  const deviceId = Cookies.get('nav_id')
  const queryParams: QueryParams = {
    terms: encodeURIComponent(search),
    page: String(page),
    resultsPerPage: '18',
    sortBy: order || ProductsSortingKey.Relevance,
    productFormat: 'complete',
    showOnlyAvailable: 'false',
    deviceId,
  }

  let filterString = ''

  if (Array.isArray(filter)) {
    filterString = filter.join('&filter=')
    filterString = filterString ? `&filter=${filterString}` : ''
  } else if (filter) {
    filterString = `&filter=${filter}`
  }

  const completeUrl = new URLSearchParams(queryParams) + filterString

  try {
    const { data } = await axios.get<SearchProductsResponse>(
      `https://api.linximpulse.com/engage/search/v3/search?apiKey=${API_KEY_LINX}&${completeUrl}`
    )

    return data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return error.response?.data
    }
    return undefined
  }
}
